import { ChannelStatus, ChannelStatusMap } from '@/models/channels'

export const NON_MEMBER_TAG = { type: 'NON_MEMBER', label: 'NÃO MEMBRO' }

export const ARCHIVED_CHANNEL_TAG = {
  type: ChannelStatus.ARCHIVED,
  label: ChannelStatusMap.ARCHIVED
}

export const FIRST_ACCESS_CHANNEL_TAG = {
  type: 'FIRST_ACCESS',
  label: 'Primeiro acesso',
  value: 'primeiro_acesso'
}
